var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_002-calendar",
    "data-name": "002-calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.678,
    height: 19.678,
    viewBox: "0 0 19.678 19.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15460",
    "data-name": "Path 15460",
    d: "M188.73,366.03l-.636-.636-1.482,1.482-.582-.582-.636.636,1.218,1.218Z",
    transform: "translate(-177.835 -350.114)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15461",
    "data-name": "Path 15461",
    d: "M62.7,241H60v2.7h2.7Zm-.9,1.8h-.9v-.9h.9Z",
    transform: "translate(-58.2 -231.304)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15462",
    "data-name": "Path 15462",
    d: "M62.7,361H60v2.7h2.7Zm-.9,1.8h-.9v-.9h.9Z",
    transform: "translate(-58.2 -345.852)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15463",
    "data-name": "Path 15463",
    d: "M213.7,241H211v2.7h2.7Zm-.9,1.8h-.9v-.9h.9Z",
    transform: "translate(-202.511 -231.304)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15464",
    "data-name": "Path 15464",
    d: "M364.7,241H362v2.7h2.7Zm-.9,1.8h-.9v-.9h.9Z",
    transform: "translate(-346.822 -231.304)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15465",
    "data-name": "Path 15465",
    d: "M364.7,361H362v2.7h2.7Zm-.9,1.8h-.9v-.9h.9Z",
    transform: "translate(-346.822 -345.852)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15466",
    "data-name": "Path 15466",
    d: "M15.642,0c-1.049,0-1.577,1.247-1.7,2.306h-2.41C11.414,1.238,10.882,0,9.839,0s-1.577,1.247-1.7,2.306H5.732C5.611,1.237,5.079,0,4.035,0s-1.577,1.247-1.7,2.306H0V19.678H19.678V2.306H17.339C17.218,1.238,16.686,0,15.642,0Zm0,1.153c.255,0,.492.867.534,1.153H15.108C15.155,1.989,15.4,1.153,15.642,1.153Zm-5.8,0c.255,0,.492.867.534,1.153H9.3C9.352,1.989,9.593,1.153,9.839,1.153Zm-5.8,0c.255,0,.492.867.534,1.153H3.5C3.549,1.989,3.789,1.153,4.035,1.153ZM18.525,18.525H1.153V8.109H18.525Zm0-11.568H1.153v-3.5H4.57a2.711,2.711,0,0,1-.235.8c-.147.295-.28.357-.3.357V5.765a1.539,1.539,0,0,0,1.331-.994,3.969,3.969,0,0,0,.366-1.312h4.641a2.711,2.711,0,0,1-.235.8c-.147.295-.28.357-.3.357V5.765a1.539,1.539,0,0,0,1.331-.994,3.968,3.968,0,0,0,.366-1.312h4.641a2.71,2.71,0,0,1-.235.8c-.147.295-.28.357-.3.357V5.765a1.539,1.539,0,0,0,1.331-.994,3.966,3.966,0,0,0,.366-1.312h1.186Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b5af7ada450c09e011d1b808198cb9d3.svg";
export { ForwardRef as ReactComponent };